


function scroll_down(e) {
	e.preventDefault();

	const $header = $("#header");
	const $target = $($(this).attr("href"));
	const vertical = $target.offset().top - $header.height();

	window.scrollTo({
		top: vertical,
		left: 0,
		behavior: "smooth"
	});
}

export function init() {
	let $anchors = $(".anchor");
	if ($anchors.length) {
		$anchors.on("click", scroll_down);
	}
}
